import { useEffect } from 'react';
import { useBigQuery } from '../BigQuery';

export const PageViewTracker = () => {
  const bigQuery = useBigQuery();

  useEffect(() => {
    bigQuery.trackPageView();
  }, [bigQuery]);

  return null;
};
